import {
    deliveryModeId,
    onlineNatureId,
    detailLocations,
} from '../shared/programRequestDetailsModel';

export const createConsolidateProgramsModel = () => ({
    institutionId: null,
    sourceProgramIds: [],
    formalName: '',
    cipCode: null,
    locations: [],
    degreeLevel: null,
    deliveryMode: null,
    onlineNature: null,
    creditMin: '',
    creditMax: '',
    sourceProgramTeachouts: {},
    comments: '',
});

export const createConsolidateProgramsEditModel = details => ({
    institutionId: details?.institutionId ?? null,
    sourceProgramIds: String(details?.consolidatedProgramIds ?? '')
        .split(',')
        .map(value => Number(value.trim()))
        .filter(Boolean),
    formalName: details?.programName ?? '',
    cipCode: details?.cipCode ?? null,
    locations: detailLocations(details),
    degreeLevel: details?.degreeLevelId ?? null,
    deliveryMode: deliveryModeId(details?.deliveryMode),
    onlineNature: onlineNatureId(details?.deliveryModeOnline),
    creditMin: details?.creditRequirementMinimum ?? '',
    creditMax: details?.creditRequirementMaximum ?? '',
    // Existing requests stored one shared pair of flags. Use it as the initial value
    // for every source program until the request is resubmitted with per-program values.
    sourceProgramTeachouts: String(details?.consolidatedProgramIds ?? '')
        .split(',')
        .map(value => Number(value.trim()))
        .filter(Boolean)
        .reduce((values, programId) => ({
            ...values,
            [programId]: {
                teachoutFlag: typeof details?.teachoutFlag === 'boolean' ? details.teachoutFlag : null,
                allStudentsTaughtOut: typeof details?.allStudentsTaughtOut === 'boolean'
                    ? details.allStudentsTaughtOut
                    : null,
            },
        }), {}),
    comments: '',
});

export const toCreateConsolidateRequest = form => ({
    institutionId: form.institutionId,
    sourceProgramIds: form.sourceProgramIds,
    formalName: form.formalName.trim(),
    cipCode: form.cipCode,
    degreeLevel: form.degreeLevel,
    distanceEdApproved: { id: form.deliveryMode },
    distanceEdOnline: { id: form.onlineNature ?? 0 },
    creditRequirementMinimum:
        form.creditMin !== '' ? Number(form.creditMin) : null,
    creditRequirementMaximum:
        form.creditMax !== '' ? Number(form.creditMax) : null,
    locationStatusChanges: form.locations.map(location => ({
        locationId: location.value,
        statusId: Number(location.statusId ?? 1),
    })),
    sourceProgramTeachouts: form.sourceProgramIds.map(programId => ({
        programId,
        teachoutFlag: form.sourceProgramTeachouts?.[programId]?.teachoutFlag ?? null,
        allStudentsTaughtOut:
            form.sourceProgramTeachouts?.[programId]?.teachoutFlag === true
                ? form.sourceProgramTeachouts?.[programId]?.allStudentsTaughtOut ?? null
                : null,
    })),
    comments: form.comments || null,
});

export const toEditConsolidateRequest = (form, details) => ({
    ...toCreateConsolidateRequest(form),
    requestId: details?.requestID ?? details?.requestId,
});
